import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNoStatus'
})
export class YesNoStatusPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value == 'Y') {
      return 'ACTIVE';
    } else if (value == 'N') {
      return 'INACTIVE';
    }
  }

}
